import { CartLinesUpdateEvent } from '@shopify/events';

class SayeBuyForm extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-variants-json]').textContent);
    this.variantIdInput = this.querySelector('[data-variant-id]');
    this.swatches = Array.from(this.querySelectorAll('[data-swatch]'));
    this.submitBtn = this.querySelector('[data-submit]');
    this.submitLabel = this.querySelector('[data-submit-label]');
    this.form = this.querySelector('form');

    this.selectedOptions = this.swatches.length
      ? [this.swatches.find((s) => s.classList.contains('is-selected'))?.dataset.optionValue || this.swatches[0].dataset.optionValue]
      : [];

    this.swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => this._selectSwatch(swatch));
    });

    if (this.form) {
      this.form.addEventListener('submit', (event) => this._addToCart(event));
    }
  }

  _selectSwatch(swatch) {
    this.swatches.forEach((s) => s.classList.remove('is-selected'));
    swatch.classList.add('is-selected');
    this.selectedOptions = [swatch.dataset.optionValue];
    const label = this.querySelector('[data-swatch-label]');
    if (label) label.textContent = swatch.dataset.optionValue;
    this._syncVariant();
  }

  _syncVariant() {
    const match = this.variants.find((variant) =>
      this.selectedOptions.every((value) => variant.options.includes(value))
    );
    if (!match) return;
    this.variantIdInput.value = match.id;
    // Price/compare-price text is set manually in the section settings, not
    // pulled from the variant, so switching colors doesn't touch it here.
    if (this.submitBtn) this.submitBtn.disabled = !match.available;
    if (this.submitLabel) {
      this.submitLabel.textContent = match.available
        ? this.dataset.buyLabel
        : this.dataset.soldOutLabel;
    }
  }

  async _addToCart(event) {
    event.preventDefault();
    if (this.submitBtn.disabled) return;

    const originalLabel = this.submitLabel.textContent;
    this.submitBtn.disabled = true;
    this.submitLabel.textContent = this.dataset.addingLabel;

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: this.variantIdInput.value, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: this.variantIdInput.value, quantity: 1 }] }),
      });

      if (!response.ok) throw new Error('Add to cart failed');

      const cart = await fetch('/cart.js').then((r) => r.json());

      this.submitLabel.textContent = this.dataset.addedLabel;
      this._updateCartBadge(cart);
      this._openCartDrawer();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'saye-buy-form' },
      });
    } catch (error) {
      this.submitLabel.textContent = this.dataset.errorLabel;
      deferred.reject(error);
    } finally {
      setTimeout(() => {
        this.submitLabel.textContent = originalLabel;
        this.submitBtn.disabled = false;
      }, 1600);
    }
  }

  _updateCartBadge(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  _openCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }
}

customElements.define('saye-buy-form', SayeBuyForm);
